import changeGlobalContent from './change-global-content';
import extractGlobalContent from './extract-global-content';
import detachGlobal from './detach-global';
import resetGlobal from './reset-global';

export default {
  changeGlobalContent,
  extractGlobalContent,
  detachGlobal,
  resetGlobal,
};
